export default __webpack_public_path__ + "static/media/Icons_Mail_Regular.296a5ad9.svg";